import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack, Typography } from '@mui/material';

interface ErrorViewProps {
  message: string;
}

export const ErrorView = ({ message }: ErrorViewProps) => {
  return (
    <Stack direction="column" alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
      <ErrorOutlineIcon />
      <Typography color="error">{message}</Typography>
    </Stack>
  );
};
